import { useRCAHistoryMainStyles } from "../../RCA.styles";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const RCATextChangeLog = ({ newValue, oldValue }: { newValue: string | null; oldValue: string | null }) => {
    const classes = useRCAHistoryMainStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.historyChangeWrapper}>
            <span className={classes.historyText}>{oldValue || t("rca.history_audit_logs.nothing")}</span>
            <ArrowForwardIcon />
            <span className={classes.historyText}>{newValue || t("rca.history_audit_logs.nothing")}</span>
        </div>
    );
};
